export class MealItemSelectionEntity {
  itemValueIds?: string[]
  simpleValueIds?: string[]
  selectionId?: string
}
